import React from 'react';
import PropTypes from 'prop-types';

const MEDIA_COMPONENTS = ['picture', 'img'];

const MediaComponent = (props) => {
  const {
    className,
    component: Component,
    image,
    imgClass,
    src,
    srcset,
    staticImage,
    ...other
  } = props;

  const isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;

  return (
    <Component
      className={className}
      src={isMediaComponent ? image || src : undefined}
      srcSet={srcset}
      {...other}
    />
  );
};

MediaComponent.propTypes = {
  className: PropTypes.string,
  imgClass: PropTypes.string,
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  image: PropTypes.string,
  src: PropTypes.string,
  srcset: PropTypes.string,
  staticImage: PropTypes.bool,
};

MediaComponent.defaultProps = {
  component: 'div',
  className: '',
  imgClass: '',
  image: '',
  src: '',
};

export default MediaComponent;
